import category from './category';
import question from './question';

export default [...category, ...question];
